import React from 'react';
import "../css/Features.css";
function Features() {
    return (
        <section className="section" id="social">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-heading">
                            <h2>Features</h2>
                            <span>These are the premium Features will be supported</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row images">
                    <div className="col-2">
                        <div className="thumb">
                            <div className="icon">
                                <a href="/">
                                    <h6>24/7 support available</h6>
                                    <i className="fa fa-lock"></i>
                                </a>
                            </div>
                            <img src="https://cdn-6212c8e2c1ac198840e9c663.closte.com/wp-content/uploads/2020/04/bluepied1.jpg" alt="" />
                        </div>
                    </div>
                    <div className="col-2">
                        <div className="thumb">
                            <div className="icon">
                                <a href="/">
                                    <h6>24/7 support available</h6>
                                    <i className="fa fa-lock"></i>
                                </a>
                            </div>
                            <img src="https://cdn-6212c8e2c1ac198840e9c663.closte.com/wp-content/uploads/2021/01/Carter_TomKings_Puppies_1.jpg" alt="" />
                        </div>
                    </div>
                    <div className="col-2">
                        <div className="thumb">
                            <div className="icon">
                                <a href="/">
                                    <h6>24/7 support available</h6>
                                    <i className="fa fa-like"></i>
                                </a>
                            </div>
                            <img src="https://cdn-6212c8e2c1ac198840e9c663.closte.com/wp-content/uploads/2020/04/Blue_and_Tan_Frenchie_TomKings_Puppies.jpg" alt="" />
                        </div>
                    </div>
                    <div className="col-2">
                        <div className="thumb">
                            <div className="icon">
                                <a href="/">
                                    <h6>24/7 support available</h6>
                                    <i className="fa fa-instagram"></i>
                                </a>
                            </div>
                            <img src="https://cdn-6212c8e2c1ac198840e9c663.closte.com/wp-content/uploads/2020/04/Merle_Frenchie_TomKings_Puppies_3.jpg" alt="" />
                        </div>
                    </div>
                    <div className="col-2">
                        <div className="thumb">
                            <div className="icon">
                                <a href="http://instagram.com">
                                    <h6>24/7 support available</h6>
                                    <i className="fa fa-instagram"></i>
                                </a>
                            </div>
                            <img src="https://cdn-6212c8e2c1ac198840e9c663.closte.com/wp-content/uploads/2020/04/lilacandtan1.jpg" alt="" />
                        </div>
                    </div>
                    <div className="col-2">
                        <div className="thumb">
                            <div className="icon">
                                <a href="/">
                                    <h6>24/7 support available</h6>
                                    <i className="fa fa-like"></i>
                                </a>
                            </div>
                            <img src="https://cdn-6212c8e2c1ac198840e9c663.closte.com/wp-content/uploads/2020/04/1-1-1-e1586445376100.jpg" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Features;
